import { useClient } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import { getAktualitaDetail } from '../../../client/aktualitaDetailClient';
import Aktualita from '../../../model/Aktualita';

interface ReturnType {
  data: Aktualita;
  status: ClientStatus;
}

export default (
  id: string | undefined,
): ReturnType => {
  const {
    data,
    status,
  } = useClient(
    () => getAktualitaDetail(id),
    [],
  );

  return <ReturnType>{
    data,
    status,
  };
};
